import React, {useEffect, useState} from 'react';
import './styles.scss';
import {connect} from 'react-redux';
import {useHistory, withRouter} from 'react-router-dom';
import {
  addToGlobalStyles,
  addToWizard,
  setGlobalStyles,
  setWizard,
} from '../../../store/actions';
import {compose} from 'redux';
import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import colors, {pageBackgrounds} from '../../../util/colors';
import SubmitNumber from './submit-number/SubmitNumber';
import {useFormikContext} from 'formik';
import EnterCodeMobile from './enter-code/EnterCodeMobile';
import {patch, post} from '../../../api/api';
import {uriPatchContacts, uriSendOTPCode} from '../../../api/endpoints';

const ConfirmMobile = (props: any) => {
  const [stepNumber, setStepNumber] = useState(0);
  const [mobileNumber, setMobileNumber] = useState('');
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [showForbiddenError, setShowForbiddenError] = useState(false);
  const [showResendConfirmation, setShowResendConfirmation] = useState(false);
  const [disableResend, setDisableResend] = useState(false);
  const [showSubmitCodeError, setShowSubmitCodeError] = useState(false);
  const [showWrongCodeError, setShowWrongCodeError] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const history = useHistory();

  const formik = useFormikContext<any>();

  const [formikContext, setFormikContext] = useState<any>();
  const route = (history.location.state as any)?.screen;

  useEffect(() => {
    props.addToGlobalStyles({
      background: pageBackgrounds.registerPage,
    });
  }, []);

  useEffect(() => {
    if (formikContext && (formikContext?.dirty as any)) {
      (formikContext as any)?.validateForm((formikContext as any)?.values);
    }
  }, [formikContext]);

  const submitMobile = async (mobileNumber: any, isResend = false) => {
    try {
      setShowGeneralError(false);
      setShowForbiddenError(false);
      if (isResend) {
        setShowResendConfirmation(false);
        setDisableResend(true);
        setShowWrongCodeError(false);
        setFormKey((k) => k + 1);
      }

      const body = {
        contact: mobileNumber,
        senderType: 'SMS',
      };
      const res = await post(uriSendOTPCode(), JSON.stringify(body));
      setMobileNumber(mobileNumber);
      setStepNumber(1);
      if (isResend) {
        setShowResendConfirmation(true);
      }
    } catch (error: any) {
      if (error.status === 403) {
        setShowForbiddenError(true);
      } else {
        setShowGeneralError(true);
      }
    } finally {
      setDisableResend(false);
    }
  };

  const submitCode = async (code: any) => {
    try {
      setShowSubmitCodeError(false);
      setShowWrongCodeError(false);
      const body = {
        contact: mobileNumber,
        senderType: 'SMS',
        code: code,
      };
      const res = await patch(uriPatchContacts(), body);
      setShowSuccessModal(true);
    } catch (error: any) {
      if (error.status === 400) {
        setShowWrongCodeError(true);
      } else {
        setShowSubmitCodeError(true);
      }
    }
  };

  return (
    <Column className="confirm-mobile-container">
      <RegisterHeader />
      <Column className="confirm-mobile-container">
        <Row className="confirm-mobile-header-row">
          <Header1
            style={{...fonts.XL, color: colors.black, fontWeight: 'bold'}}
            className="confirm-mobile">
            {props.labels?.login_confirmMobile_headerTitle}
          </Header1>
          <Header1
            style={{...fonts.L, color: colors.black, fontWeight: 'bold'}}
            className="confirm-mobile-responsive">
            {props.labels?.login_confirmMobile_headerTitle}
          </Header1>
        </Row>
        {stepNumber === 0 && (
          <SubmitNumber
            formik={formik}
            setFormikContext={setFormikContext}
            submitMobile={submitMobile}
            showForbiddenError={showForbiddenError}
            showGeneralError={showGeneralError}
          />
        )}
        {stepNumber === 1 && (
          <EnterCodeMobile
            formik={formik}
            setFormikContext={setFormikContext}
            setStepNumber={setStepNumber}
            mobileNumber={mobileNumber}
            submitMobile={submitMobile}
            disableResend={disableResend}
            showResendConfirmation={showResendConfirmation}
            showForbiddenError={showForbiddenError}
            showGeneralError={showGeneralError}
            showSubmitCodeError={showSubmitCodeError}
            showWrongCodeError={showWrongCodeError}
            submitCode={submitCode}
            showSuccessModal={showSuccessModal}
            setShowSuccessModal={setShowSuccessModal}
            route={route}
            formKey={formKey}
          />
        )}
      </Column>
    </Column>
  );
};

const mapStateToProps = ({
  wizard,
  user,
  purposes,
  strings,
  stringsDefault,
  globalStyles,
  digitalCommunications,
  tenant,
  busFuncMapDefault,
}: any) => ({
  wizard: wizard.value,
  user: user.value,
  purposes: purposes.value,
  labels: strings.value.pt.login,
  labelsDefault: stringsDefault.value,
  oneTrust: strings.value.pt.oneTrust,
  globalStyles: globalStyles.value,
  digitalCommunications: digitalCommunications.value,
  tenant: tenant.value,
  busFuncMapDefault: busFuncMapDefault.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(ConfirmMobile))
);
